import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const eventsEventsCarousels = document.querySelectorAll(
    '.block-events .block-events__carousel'
  );

  if (0 < eventsEventsCarousels.length) {
    eventsEventsCarousels.forEach((eventsEventsCarousel) => {
      new Swiper(eventsEventsCarousel, {
        slidesPerView: 1.15,
        spaceBetween: 20,
        pagination: {
          el: '.block-events .vtx-swiper__pagination',
          type: 'fraction',
        },
        navigation: {
          nextEl: '.block-events .swiper-button-next.vtx-swiper__next',
          prevEl: '.block-events .swiper-button-prev.vtx-swiper__prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 2.25,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      });
    });
  }
});
